const TTL_MS = 2 * 60 * 1000;

let snapshot = null;
let savedAt = 0;

export function getDashboardMetricsCache() {
  return snapshot;
}

export function isDashboardMetricsCacheFresh() {
  return Boolean(snapshot && Date.now() - savedAt < TTL_MS);
}

export function setDashboardMetricsCache(data) {
  snapshot = data;
  savedAt = Date.now();
}

export function clearDashboardMetricsCache() {
  snapshot = null;
  savedAt = 0;
}
